// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".history__cas-entry{height:calc(100vh - 64px);width:100%;display:block;position:relative}#history__cas-container,#history__cas-container div[data-name=\"cas-history.patsnap\"]{height:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
